import { render } from "./RefundSkeleton.vue?vue&type=template&id=9502c25a&scoped=true"
import script from "./RefundSkeleton.vue?vue&type=script&lang=js"
export * from "./RefundSkeleton.vue?vue&type=script&lang=js"

import "./RefundSkeleton.vue?vue&type=style&index=0&id=9502c25a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9502c25a"]])

export default __exports__